<template>
  <svg
    width="132"
    height="188"
    viewBox="0 0 132 188"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M60.5942 67.2917L120.571 1.93701C121.123 1.33818 121.791 0.857749 122.534 0.524902C123.277 0.192055 124.08 0.0137331 124.894 0.000762403C125.709 -0.0122083 126.517 0.140443 127.271 0.449448C128.024 0.758454 128.707 1.21737 129.278 1.79832C130.369 2.91776 130.979 4.41907 130.979 5.9822C130.979 7.54533 130.369 9.04663 129.278 10.1661L67.6367 73.348L60.5942 67.2917Z"
      fill="url(#paint0_linear_498_2914)"
    />
    <path
      opacity="0.35"
      d="M62.6592 66.5982L122.636 1.24344C123.077 0.766237 123.599 0.36988 124.177 0.0722656C122.814 0.260469 121.56 0.920219 120.632 1.9369L60.5942 67.2916L67.6367 73.3787L68.962 72.038L62.6592 66.5982Z"
      fill="#FFF1B6"
    />
    <path
      opacity="0.18"
      d="M129.277 1.79811L128.923 1.53613C129.293 8.56319 77.7763 59.5556 66.0029 72.0379L67.6364 73.4402L129.277 10.2583C130.396 9.13483 131.024 7.61381 131.024 6.02821C131.024 4.44261 130.396 2.92159 129.277 1.79811Z"
      fill="#492B17"
    />
    <path
      d="M65.6639 101.703C65.1707 102.226 57.5119 95.8312 48.5585 87.4327C39.6052 79.0341 32.7322 71.7913 33.1483 71.2673C33.5644 70.7434 41.3003 77.1386 50.2691 85.5372C59.2378 93.9358 66.157 101.24 65.6639 101.703Z"
      fill="url(#paint1_linear_498_2914)"
    />
    <path
      d="M50.731 109.947C50.2533 110.471 44.1201 105.91 37.2933 99.5143C30.4666 93.1191 25.5045 87.0167 25.9976 86.4927C26.4908 85.9688 32.2388 91.2082 39.0655 97.6189C45.8922 104.03 51.2242 109.408 50.731 109.947Z"
      fill="url(#paint2_linear_498_2914)"
    />
    <path
      d="M74.3555 89.3743C73.9086 89.8366 66.8045 84.2735 58.7141 76.6763C50.6237 69.079 44.4134 62.5605 44.8449 62.0828C45.2764 61.6051 52.211 67.3839 60.2551 74.9811C68.2993 82.5784 74.8024 88.8811 74.3555 89.3743Z"
      fill="url(#paint3_linear_498_2914)"
    />
    <path
      d="M70.5798 64.0093C66.4961 60.1721 62.0271 58.3075 60.6094 59.8177L58.4057 62.1601C56.988 63.7011 59.1454 68.0159 63.2291 71.8377C67.3128 75.6594 71.7818 77.5549 73.1995 76.0293L75.4032 73.6869C76.8209 72.1767 74.6635 67.8002 70.5798 64.0093Z"
      fill="url(#paint4_linear_498_2914)"
    />
    <path
      d="M64.9703 97.8345C55.4776 107.867 41.9782 109.885 34.3039 102.704C26.6297 95.523 27.6005 82.0082 37.1857 71.7759C47.1252 61.1736 57.9124 62.1445 65.5867 69.341C73.261 76.5376 74.9099 87.2323 64.9703 97.8345Z"
      fill="url(#paint5_linear_498_2914)"
    />
    <path
      d="M75.5111 84.6128C67.3244 76.0303 58.6165 67.9606 49.437 60.4496C56.3562 59.0318 62.9518 61.4666 68.2837 66.4595C73.6156 71.4525 76.3895 77.7244 75.5111 84.6128Z"
      fill="url(#paint6_linear_498_2914)"
    />
    <path
      opacity="0.35"
      d="M58.19 60.6808C55.33 59.9245 52.333 59.8453 49.437 60.4496L51.579 62.2372C53.7186 61.4764 55.9357 60.9545 58.19 60.6808Z"
      fill="#FFF1B6"
    />
    <path
      d="M68.5765 98.7588C57.9126 88.3415 47.0947 78.2324 35.9839 68.2928C38.5236 65.68 41.5085 63.5406 44.7985 61.9746C55.2908 70.3921 65.1682 79.5485 74.3553 89.374C73.0216 92.8305 71.0626 96.0118 68.5765 98.7588Z"
      fill="url(#paint7_linear_498_2914)"
    />
    <path
      opacity="0.35"
      d="M42.9955 66.9059C44.3578 65.8271 45.8179 64.8778 47.3566 64.0704L44.7985 61.9746C41.5085 63.5406 38.5236 65.68 35.9839 68.2928L38.6653 70.7276C40.0676 69.3407 41.6086 68.0771 42.9955 66.9059Z"
      fill="#FFF1B6"
    />
    <path
      d="M65.7254 101.703C62.7281 104.523 59.2597 106.797 55.4776 108.421C45.0794 100.57 35.6401 91.5241 27.354 81.469C28.7303 77.7878 30.7092 74.361 33.2099 71.3291C44.2898 81.2379 55.0924 91.3316 65.7254 101.703Z"
      fill="url(#paint8_linear_498_2914)"
    />
    <path
      opacity="0.35"
      d="M33.4873 77.3237C34.1735 76.0633 34.9785 74.8713 35.8913 73.7639C34.9975 72.9472 34.1191 72.1304 33.2099 71.3291C30.7092 74.361 28.7303 77.7878 27.354 81.469C28.3865 82.7172 29.4344 83.9347 30.436 85.1521C31.2156 82.4561 32.2368 79.836 33.4873 77.3237Z"
      fill="#FFF1B6"
    />
    <path
      d="M50.7317 109.947C43.566 111.611 36.5543 110.209 31.6076 105.571C26.661 100.932 24.6576 93.7202 26.0291 86.2925C33.4429 94.9918 41.7194 102.917 50.7317 109.947Z"
      fill="url(#paint9_linear_498_2914)"
    />
    <path
      opacity="0.35"
      d="M29.2803 100.763C28.7531 96.9909 28.552 93.1808 28.6793 89.3745C27.7855 88.3883 26.9071 87.3866 26.0287 86.2925C25.3385 89.4186 25.3683 92.6608 26.1158 95.7738C26.8634 98.8868 28.3091 101.789 30.3436 104.261C29.9031 103.123 29.5477 101.953 29.2803 100.763Z"
      fill="#FFF1B6"
    />
    <path
      opacity="0.21"
      d="M125.995 2.15235C127.536 1.96742 126.303 5.31144 122.913 9.00989C119.523 12.7083 100.769 34.9761 98.75 33.0806C97.7792 32.1714 122.944 2.50678 125.995 2.15235Z"
      fill="#FFF1B6"
    />
    <path
      opacity="0.84"
      d="M68.2836 66.4593C65.0012 63.0382 54.0754 72.1457 51.3324 75.7054C48.5894 79.2652 44.6906 92.1943 36.7235 90.0061C28.7564 87.8178 26.2754 83.3643 24.3953 89.3897C22.5153 95.4151 29.2341 104.261 27.6623 128.639C27.6623 128.639 26.9072 167.011 26.9072 172.482C26.9072 177.952 0.278338 178.307 0.000954342 183.515C-0.27643 188.724 60.0083 189.679 56.726 184.532C53.4436 179.385 30.9601 175.764 30.4207 160.153C30.0663 149.936 30.1742 141.661 30.282 137.254C30.8467 137.517 31.442 137.709 32.0542 137.824C39.3278 139.195 38.357 126.035 39.0504 119.594C39.7439 113.152 44.6598 113.029 49.7297 111.889C54.7997 110.748 68.6843 105.725 72.6139 98.4509C81.8908 81.2377 71.566 69.8803 68.2836 66.4593Z"
      fill="url(#paint10_linear_498_2914)"
    />
    <path
      d="M56.4639 184.194H56.3715C50.8546 186.259 42.5023 187.769 22.469 186.752C17.2603 186.49 4.6856 186.921 1.57274 181.481C0.601894 182.067 0.0317161 182.714 0.0317161 183.469C-0.245668 188.678 60.0391 189.633 56.7567 184.486L56.4639 184.194Z"
      fill="url(#paint11_linear_498_2914)"
    />
    <path
      opacity="0.57"
      d="M10.0949 179.601C12.7763 179.478 15.4731 179.463 18.1699 179.416C20.8667 179.37 23.4556 179.293 26.0907 179.139C27.9554 179.031 33.3489 179.231 34.5047 177.444C35.6605 175.656 31.0374 174.886 29.8816 174.254C28.6981 173.545 27.7865 172.46 27.2927 171.172C27.1232 170.787 26.9691 170.386 26.8304 169.985C26.8304 171.095 26.8304 171.973 26.8304 172.513C26.8304 176.442 13.2232 177.721 5.37939 180.048C6.96665 179.91 8.52308 179.678 10.0949 179.601Z"
      fill="url(#paint12_linear_498_2914)"
    />
    <path
      opacity="0.35"
      d="M70.4099 100.763C65.494 104.6 58.4207 105.386 52.4262 106.064C49.1284 106.465 45.6919 106.449 42.5482 107.605C39.1271 108.822 37.8481 111.427 37.9251 114.909C38.1223 116.887 38.4779 118.845 38.9884 120.765C38.9884 120.365 38.9884 119.995 39.0963 119.625C39.7744 113.199 44.7056 113.06 49.7756 111.92C54.8456 110.779 68.1446 106.002 72.3824 98.9443C71.7755 99.6031 71.1158 100.211 70.4099 100.763Z"
      fill="url(#paint13_linear_498_2914)"
    />
    <path
      d="M38.3724 128.809C38.3724 128.809 38.1259 136.699 34.1809 137.778C32.3625 138.271 29.0801 137.3 29.0801 135.497C29.0801 135.497 31.7769 137.192 33.7031 136.422C36.5232 135.281 38.3724 128.809 38.3724 128.809Z"
      fill="url(#paint14_linear_498_2914)"
    />
    <path
      d="M36.385 116.851C36.0768 116.096 35.9073 119.147 34.844 122.538C34.2276 124.556 29.6045 133.232 31.7619 134.311C33.9193 135.39 35.7069 132.431 36.385 130.844C37.1855 128.793 37.5731 126.604 37.5253 124.402C37.6488 121.835 37.2612 119.268 36.385 116.851Z"
      fill="url(#paint15_linear_498_2914)"
    />
    <path
      d="M40.0678 91.4706C35.7683 91.4706 30.7138 91.6401 27.7396 88.3886C26.9074 87.4639 25.4281 88.3886 25.1353 89.2669C24.3956 91.4552 26.214 93.3815 28.0786 94.1828C30.4168 94.9511 32.9489 94.8858 35.2444 93.9979C37.8949 93.1041 40.7458 91.4552 40.0678 91.4706Z"
      fill="url(#paint16_linear_498_2914)"
    />
    <path
      d="M45.723 180.295C42.915 179.385 40.3018 177.958 38.0179 176.088C36.3381 174.793 39.4202 179.432 42.5485 181.666C45.6767 183.901 53.0736 187.152 54.3681 184.579C55.2311 182.668 46.74 180.588 45.723 180.295Z"
      fill="url(#paint17_linear_498_2914)"
    />
    <path
      d="M17.7071 184.702C12.7717 184.202 7.88238 183.321 3.08283 182.067C1.92707 181.666 1.43394 183.485 2.5743 183.885C4.85622 184.644 7.2115 185.16 9.60136 185.426C12.1132 185.735 14.6251 186.012 17.137 186.228C22.174 186.69 27.2405 186.736 32.2852 186.367C33.4256 186.197 22.6384 185.18 17.7071 184.702Z"
      fill="url(#paint18_linear_498_2914)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_498_2914"
        x1="102.532"
        y1="65.2347"
        x2="89.2125"
        y2="8.17912"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DD9A68" />
        <stop offset="0.25" stop-color="#D99561" />
        <stop offset="0.6" stop-color="#CF894F" />
        <stop offset="1" stop-color="#BF7532" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_498_2914"
        x1="48.4953"
        y1="86.4427"
        x2="50.2558"
        y2="84.5528"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DD9A68" />
        <stop offset="0.25" stop-color="#D99561" />
        <stop offset="0.6" stop-color="#CF894F" />
        <stop offset="1" stop-color="#BF7532" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_498_2914"
        x1="37.2255"
        y1="98.4056"
        x2="38.9965"
        y2="96.5044"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DD9A68" />
        <stop offset="0.25" stop-color="#D99561" />
        <stop offset="0.6" stop-color="#CF894F" />
        <stop offset="1" stop-color="#BF7532" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_498_2914"
        x1="58.5973"
        y1="75.5982"
        x2="60.1796"
        y2="73.8995"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DD9A68" />
        <stop offset="0.25" stop-color="#D99561" />
        <stop offset="0.6" stop-color="#CF894F" />
        <stop offset="1" stop-color="#BF7532" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_498_2914"
        x1="63.0926"
        y1="70.7724"
        x2="70.3964"
        y2="62.9315"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DD9A68" />
        <stop offset="0.25" stop-color="#D99561" />
        <stop offset="0.6" stop-color="#CF894F" />
        <stop offset="1" stop-color="#BF7532" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_498_2914"
        x1="34.3277"
        y1="101.652"
        x2="65.4187"
        y2="68.2748"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DD9A68" />
        <stop offset="0.25" stop-color="#D99561" />
        <stop offset="0.6" stop-color="#CF894F" />
        <stop offset="1" stop-color="#BF7532" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_498_2914"
        x1="62.2609"
        y1="71.5525"
        x2="68.0453"
        y2="65.3428"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EAAF88" />
        <stop offset="0.3" stop-color="#EAAD81" />
        <stop offset="0.74" stop-color="#EAA76F" />
        <stop offset="1" stop-color="#EAA260" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_498_2914"
        x1="52.1736"
        y1="82.4938"
        x2="59.9804"
        y2="74.1129"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EAAF88" />
        <stop offset="0.3" stop-color="#EAAD81" />
        <stop offset="0.74" stop-color="#EAA76F" />
        <stop offset="1" stop-color="#EAA260" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_498_2914"
        x1="40.6885"
        y1="94.8237"
        x2="49.5746"
        y2="85.2841"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EAAF88" />
        <stop offset="0.3" stop-color="#EAAD81" />
        <stop offset="0.74" stop-color="#EAA76F" />
        <stop offset="1" stop-color="#EAA260" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_498_2914"
        x1="31.5331"
        y1="104.427"
        x2="38.512"
        y2="96.9351"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EAAF88" />
        <stop offset="0.3" stop-color="#EAAD81" />
        <stop offset="0.74" stop-color="#EAA76F" />
        <stop offset="1" stop-color="#EAA260" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_498_2914"
        x1="38.2029"
        y1="187.969"
        x2="38.2029"
        y2="65.7042"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FC9706" />
        <stop offset="0.49" stop-color="#FEAA05" stop-opacity="0.84" />
        <stop offset="1" stop-color="#FFBC04" stop-opacity="0.7" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_498_2914"
        x1="28.4327"
        y1="187.969"
        x2="28.4327"
        y2="65.7044"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FC9815" />
        <stop offset="0.02" stop-color="#FC9915" />
        <stop offset="1" stop-color="#FFBC04" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_498_2914"
        x1="20.0499"
        y1="187.969"
        x2="20.0499"
        y2="65.7198"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FC9815" />
        <stop offset="1" stop-color="#EB7D14" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_498_2914"
        x1="55.1075"
        y1="187.969"
        x2="55.1075"
        y2="66.0127"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FC9815" />
        <stop offset="1" stop-color="#EB7D14" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_498_2914"
        x1="29.0801"
        y1="133.355"
        x2="38.3724"
        y2="133.355"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FC9815" />
        <stop offset="0.02" stop-color="#FC9915" />
        <stop offset="1" stop-color="#FFBC04" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_498_2914"
        x1="31.2534"
        y1="125.635"
        x2="37.6332"
        y2="125.635"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F9E77C" stop-opacity="0" />
        <stop offset="0.01" stop-color="#F9E77E" stop-opacity="0.02" />
        <stop offset="0.3" stop-color="#FBF0AB" stop-opacity="0.36" />
        <stop offset="0.55" stop-color="#FDF6CF" stop-opacity="0.63" />
        <stop offset="0.76" stop-color="#FEFBE9" stop-opacity="0.83" />
        <stop offset="0.91" stop-color="#FFFEF9" stop-opacity="0.95" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_498_2914"
        x1="24.9195"
        y1="91.3627"
        x2="40.1448"
        y2="91.3627"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.09" stop-color="#FFFEF9" stop-opacity="0.95" />
        <stop offset="0.24" stop-color="#FEFBE9" stop-opacity="0.83" />
        <stop offset="0.45" stop-color="#FDF6CF" stop-opacity="0.63" />
        <stop offset="0.7" stop-color="#FBF0AB" stop-opacity="0.36" />
        <stop offset="0.99" stop-color="#F9E77E" stop-opacity="0.02" />
        <stop offset="1" stop-color="#F9E77C" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_498_2914"
        x1="37.4785"
        y1="180.634"
        x2="54.3835"
        y2="180.634"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F9E77C" stop-opacity="0" />
        <stop offset="0.01" stop-color="#F9E77E" stop-opacity="0.02" />
        <stop offset="0.3" stop-color="#FBF0AB" stop-opacity="0.36" />
        <stop offset="0.55" stop-color="#FDF6CF" stop-opacity="0.63" />
        <stop offset="0.76" stop-color="#FEFBE9" stop-opacity="0.83" />
        <stop offset="0.91" stop-color="#FFFEF9" stop-opacity="0.95" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_498_2914"
        x1="1.86543"
        y1="184.271"
        x2="32.316"
        y2="184.271"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.09" stop-color="#FFFEF9" stop-opacity="0.95" />
        <stop offset="0.24" stop-color="#FEFBE9" stop-opacity="0.83" />
        <stop offset="0.45" stop-color="#FDF6CF" stop-opacity="0.63" />
        <stop offset="0.7" stop-color="#FBF0AB" stop-opacity="0.36" />
        <stop offset="0.99" stop-color="#F9E77E" stop-opacity="0.02" />
        <stop offset="1" stop-color="#F9E77C" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>
